import CityPageTemplate from "../city-template/CityPageTemplate";
import { comptonConfig } from "./data";

export default function ComptonPage() {
  return <CityPageTemplate config={comptonConfig} />;
}